<template>
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-xl sm:p-6">
              <!-- Cabeçalho -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold text-gray-900">Enviar Documento</h2>
                <button @click="closeDialog" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>

              <!-- Tipo de documento -->
              <div class="mt-4">
                <label class="block text-sm font-medium text-gray-700">Tipo de Documento</label>
                <select v-model="tipo_documento" class="mt-1 block w-full border rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500">
                  <option disabled value="">Selecione</option>
                  <option value="comprovante_medico">Comprovante Médico</option>
                  <option value="autorizacao">Autorização</option>
                  <option value="outros">Outros</option>
                </select>
              </div>

              <!-- Input de arquivo -->
              <div class="mt-4">
                <label class="block text-sm font-medium text-gray-700">Selecionar Arquivo (.pdf, .jpg)</label>
                <input type="file" @change="onFileChange" accept=".pdf,.jpg,.jpeg" class="mt-1 block w-full border rounded-md shadow-sm focus:border-indigo-500 focus:ring-indigo-500" />
                <span v-if="fileError" class="text-red-500 text-sm">{{ fileError }}</span>
              </div>

              <!-- Botão -->
              <div class="mt-6">
                <button @click="sendData" :disabled="!isFormValid"
                  class="w-full inline-flex justify-center rounded-md bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 disabled:opacity-50">
                  Enviar Documento
                </button>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';

export default {
  name: 'PropostaDocumentoUpload',
  props: {
    open: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      fileBase64: '',
      tipo_documento: '',
      fileError: ''
    };
  },
  computed: {
    isFormValid() {
      return this.fileBase64 && this.tipo_documento;
    }
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      const maxSize = 10 * 1024 * 1024; // 10MB
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg'];

      if (!allowedTypes.includes(file.type)) {
        this.fileError = 'Somente arquivos .pdf ou .jpg são permitidos.';
        this.fileBase64 = '';
        return;
      }

      if (file.size > maxSize) {
        this.fileError = 'O arquivo deve ter no máximo 10MB.';
        this.fileBase64 = '';
        return;
      }

      this.fileError = '';

      const reader = new FileReader();
      reader.onload = (e) => {
        this.fileBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    sendData() {
      this.$emit('upload-documento', {
        tipo_documento: this.tipo_documento,
        base64: this.fileBase64
      });
      this.closeDialog();
    },
    closeDialog() {
      this.$emit('update-open', false);
    }
  },
  components: {
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot
  }
};
</script>
